import { Component, OnInit } from '@angular/core';

import { AlertService } from '../services/alert.service';

@Component({
    moduleId: module.id.toString(),
    selector: 'alert',
    templateUrl: 'alert.component.html'
})

export class AlertComponent {
    message: any;

    constructor(private alertService: AlertService) { }

    clearMessage(){
        this.message = null;
    }
    ngOnInit() {
        this.alertService.getMessage().subscribe(message => { this.message = message; });
    }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/directives/alert.component.ts